/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { Store } from 'mipd';
import { injected } from 'wagmi/connectors';

import type { WalletAdapter } from '../../types';
import { getTargetEIP6963, isProviderExistsEIP6963 } from '../../utils';
import { Icon } from './icon';

export const okxId = 'okx';
export const okxName = 'OKX Wallet';
export const okxRdns = 'com.okex.wallet';

const dappUrl = globalThis.window ? globalThis.window.location.host + globalThis.window.location.pathname : '';
const deeplink = `okx://wallet/dapp/url?dappUrl=${dappUrl}`;
const urlWithDeeplink = `https://www.okx.com/download?deeplink=${deeplink}`;

const getOkxConnector = (providersStore: Store) =>
  injected({
    target: () => getTargetEIP6963(providersStore, okxRdns),
  });

type Params = {
  providersStore: Store;
};

export const Okx: WalletAdapter = ({ providersStore }: Params) => ({
  walletName: okxName,
  walletId: okxId,
  type: injected.type,
  Icon,
  detector: () => isProviderExistsEIP6963(providersStore, okxRdns),
  deeplink: urlWithDeeplink,
  getConnector: () => getOkxConnector(providersStore),
});
